import { PulseModule, SharedConfigurations, isIndexedDBSupported } from '@pulse/common';
import { sharedDefaultConfigs } from './configuration';
import { PulseEnvironment } from './globals';
import { sharedProviders } from './providers';
import { IndexedDBService } from './services/indexedDB/indexeddb.service';

function buildConfig(userConfig: Partial<SharedConfigurations>): SharedConfigurations {
    const config: SharedConfigurations = {
        ...sharedDefaultConfigs,
        ...userConfig,
        initialDocURL: (window as any).paa?.idu,
    };

    if (config.mode !== 'standard') {
        config.trafficSourceDetectorStorageType = 'memory';
    }

    return config;
}

export const SharedModule = new PulseModule<SharedConfigurations>()
    .provide(sharedProviders)
    .beforeInit(buildConfig)
    .onInit(
        async (
            _config: SharedConfigurations,
            indexedDBService: IndexedDBService,
            env: PulseEnvironment,
        ) => {
            if (_config.pulseMini === true && (await isIndexedDBSupported(env.win, true))) {
                indexedDBService.deleteDB();
            } else if (await isIndexedDBSupported(env.win, true)) {
                await indexedDBService.connectDB();
            }
        },
        [IndexedDBService, PulseEnvironment],
    );
